import { AgCharts } from "ag-charts-react";

const DonutCHart = (props: any) => {
  const { report, title } =
    props;
    const { tax_payers_that_have_scanned, tax_payers_that_have_not_scanned, overall_coverage_rate } = report || {}
  const data = [
    { asset: "Contrôlés", amount: tax_payers_that_have_scanned },
    { asset: "Non-contrôlés", amount: tax_payers_that_have_not_scanned },
  ];
  const options: any = {
    data: data,
    title: {
      text: title || "Taux de couverture",
      fontWeight: "bold",
    },
    subtitle:{
      //place subtitle text at the bottom of the chart
      textAlign: "center",
      text: `${overall_coverage_rate}% des Débiteurs contrôlés`,
      verticalAlign:"bottom",
      y: -10
    },
    height: 400,
    series: [
      {
        type: "donut",
        calloutLabelKey: "asset",
        angleKey: "amount",
        innerRadiusRatio: 0.7,
        fills: ["#e33621", "#e5e6eb"],
        strokes: ["#e33621", "#e5e6eb"],
      },
    ],
  };

  return <>
  <AgCharts options={options} />
  </>
};

export default DonutCHart;
